import Component from '../../../shared/component';

export default class AvatarBuilderDescriptionModal extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$avatarBuilderModal = $('#avatarBuilderModal');
    this.$startButton = this.$element.find(
      '.menteeAvatarBuilderDescriptionModal-start-button'
    );

    this.bindEvents();
    if (this.$element.hasClass('modalAutoOpen')) this.showModal();
  }

  bindEvents() {
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleShowAvatarBuilder = this.handleShowAvatarBuilder.bind(this);

    this.$element.on(
      'show.bs.modal.AvatarBuilderDescriptionModal',
      this.handleModalShow
    );
    this.$startButton.on(
      'click.AvatarBuilderDescriptionModalStartButton',
      this.handleShowAvatarBuilder
    );
  }

  unbindEvents() {
    this.$element.off(
      'show.bs.modal.AvatarBuilderDescriptionModal',
      this.handleModalShow
    );
    this.$startButton.off(
      'click.AvatarBuilderDescriptionModalStartButton',
      this.handleShowAvatarBuilder
    );
  }

  showModal() {
    this.$element.modal('show');
  }

  handleModalShow(event) {
    const eventSource = $(event.relatedTarget).data('event-source');

    this.markModalAsRead(eventSource);
  }

  markModalAsRead(eventSource) {
    $.ajax({
      url: this.$element.data('update-url'),
      type: 'PUT',
      data: {
        // eslint-disable-next-line camelcase
        user: {mentee_avatar_builder_welcome_modal_read_at: new Date()},
        // eslint-disable-next-line camelcase
        event_source: eventSource,
      },
      dataType: 'json',
    });
  }

  handleShowAvatarBuilder() {
    this.$element.modal('hide');
    this.$avatarBuilderModal.modal('show');

    $.ajax({
      url: this.$element.data('update-url'),
      type: 'PUT',
      // eslint-disable-next-line camelcase
      data: {user: {mentee_avatar_builder_first_opened_at: new Date()}},
      dataType: 'json',
    });
  }
}
